export class AxiosException extends Error {
    constructor(error) {
        super(error.message);
        const responseMessage = error.response && error.response.data ? `Response: ${JSON.stringify(error.response.data)}` : '';
        const errorMessage = responseMessage && error.message && !error.message.includes(responseMessage)
            ? `${error.message} ${responseMessage}`
            : responseMessage || error.message || '';
        Object.assign(this, error);
        this.message = errorMessage;
        this.name = error.constructor.name;
        this.code = error.code;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AxiosException);
        }
    }
}
//# sourceMappingURL=AxiosException.js.map